import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.ConfirmationPopup', {
    title: 'Please confirm the action',
    areYouSure: 'Are you sure you want to do this?',
    buttonCancel: 'Cancel',
    buttonConfirm: "Yes, I'm sure",
});
